const DXF_VERSION = "AC1024"; // AutoCAD 2010
const INSUNITS_METERS = 6;

const fmt = (n) => Number(n).toFixed(3);

function polylineEntity(points, layer, closed = true) {
  if (!Array.isArray(points) || points.length === 0) return null;
  const vertices = points
    .map(([x, y]) => ["10", fmt(x), "20", fmt(y), "30", "0.0"].join("\n"))
    .join("\n");
  return [
    "0",
    "LWPOLYLINE",
    "8",
    layer,
    "90",
    String(points.length),
    "70",
    closed ? "1" : "0",
    vertices,
  ].join("\n");
}

function buildHeader(bounds) {
  return [
    "0",
    "SECTION",
    "2",
    "HEADER",
    "9",
    "$ACADVER",
    "1",
    DXF_VERSION,
    "9",
    "$INSUNITS",
    "70",
    String(INSUNITS_METERS),
    "9",
    "$EXTMIN",
    "10",
    fmt(bounds.minX),
    "20",
    fmt(bounds.minY),
    "30",
    "0.0",
    "9",
    "$EXTMAX",
    "10",
    fmt(bounds.maxX),
    "20",
    fmt(bounds.maxY),
    "30",
    "0.0",
    "0",
    "ENDSEC",
  ].join("\n");
}

function buildTables(layers) {
  const ltypeTable = [
    "0",
    "TABLE",
    "2",
    "LTYPE",
    "70",
    "1",
    "0",
    "LTYPE",
    "2",
    "CONTINUOUS",
    "70",
    "0",
    "3",
    "Solid line",
    "72",
    "65",
    "73",
    "0",
    "40",
    "0.0",
    "0",
    "ENDTAB",
  ].join("\n");

  const layerEntries = layers.map((name, idx) =>
    [
      "0",
      "LAYER",
      "2",
      name,
      "70",
      "0",
      "62",
      String(idx === 0 ? 3 : 7),
      "6",
      "CONTINUOUS",
    ].join("\n")
  );

  const layerTable = [
    "0",
    "TABLE",
    "2",
    "LAYER",
    "70",
    String(layerEntries.length),
    ...layerEntries,
    "0",
    "ENDTAB",
  ].join("\n");

  return [
    "0",
    "SECTION",
    "2",
    "TABLES",
    ltypeTable,
    layerTable,
    "0",
    "ENDSEC",
  ].join("\n");
}

function buildBlocksSection() {
  return ["0", "SECTION", "2", "BLOCKS", "0", "ENDSEC"].join("\n");
}

function buildEntities(outlineEntity, blockEntities) {
  return [
    "0",
    "SECTION",
    "2",
    "ENTITIES",
    outlineEntity,
    blockEntities,
    "0",
    "ENDSEC",
    "0",
    "EOF",
  ].join("\n");
}

export function computeBounds(points) {
  return points.reduce(
    (acc, [x, y]) => ({
      minX: Math.min(acc.minX, x),
      minY: Math.min(acc.minY, y),
      maxX: Math.max(acc.maxX, x),
      maxY: Math.max(acc.maxY, y),
    }),
    { minX: Infinity, minY: Infinity, maxX: -Infinity, maxY: -Infinity }
  );
}

export function generateDxf({ outlineEnu, bufferEnu = null, placementsEnu = [] }) {
  if (!Array.isArray(outlineEnu) || outlineEnu.length < 3) return null;
  const allPoints = [
    ...outlineEnu,
    ...(Array.isArray(bufferEnu) ? bufferEnu : []),
    ...placementsEnu.flat(),
  ];
  const bounds = computeBounds(allPoints);
  if (!isFinite(bounds.minX) || !isFinite(bounds.minY) || !isFinite(bounds.maxX) || !isFinite(bounds.maxY)) {
    return null;
  }

  const outlineEntity = polylineEntity(outlineEnu, "SITE_OUTLINE");
  const bufferEntity = polylineEntity(bufferEnu, "SITE_BUFFER");
  const blockEntities = placementsEnu
    .map((rect, idx) => polylineEntity(rect, `BLOCK_${idx + 1}`))
    .filter(Boolean)
    .join("\n");

  const tableLayers = [
    "SITE_OUTLINE",
    ...(bufferEntity ? ["SITE_BUFFER"] : []),
    ...placementsEnu.map((_, idx) => `BLOCK_${idx + 1}`),
  ];

  const parts = [
    buildHeader(bounds),
    buildTables(tableLayers),
    buildBlocksSection(),
    buildEntities(outlineEntity, [bufferEntity, blockEntities].filter(Boolean).join("\n")),
  ];

  return parts.filter(Boolean).join("\n");
}

export default generateDxf;
